import styled from 'styled-components';

type TSearchInputSC = {
  isBlock?: boolean;
};

export const SearchInputSC = styled.div<TSearchInputSC>`
  ${({ isBlock }) => (isBlock ? `width: 100%;` : `width: 180px;`)};
`;
